<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [showHeader]="false"
  [style]="{ width: '1050px', borderRadius: '10px' }"
  [contentStyle]="{ padding: '0' }"
  (onHide)="close()"
>
  <div class="dialog-content">
    <div class="dialog-header">
      <div class="header-text">
        <h2>Edit Extra XCO (ADDP) Request</h2>
        <p>Review the information below and apply your changes.</p>
      </div>
      <button type="button" class="close-btn" (click)="close()" aria-label="Close">
        <i class="fa fa-close"></i>
      </button>
    </div>

    <div class="dialog-body">
      <div *ngIf="companyDetailsError" class="error-banner">{{ companyDetailsError }}</div>
      <div *ngIf="serviceItemsError" class="error-banner">{{ serviceItemsError }}</div>
      <div *ngIf="submissionError" class="error-banner">{{ submissionError }}</div>

      <div class="loading-container" *ngIf="loading">
        <p>Loading ADDP context…</p>
      </div>

      <ng-container *ngIf="!loading && canDisplayForm; else missingData">
        <app-addp-cart-form
          [companyId]="initialPayload?.company?.id || 0"
          [pop]="pop"
          [xcoId]="xcoId"
          [serviceLabel]="serviceLabel"
          [selectedItems]="selectedItems"
          [companyDetails]="companyDetails"
          [loading]="companyDetailsLoading"
          [submitting]="submitting"
          [initialPayload]="initialPayload"
          [submitLabel]="'Save'"
          (cancel)="handleCancel()"
          (submitOrder)="handleSubmit($event)"
        ></app-addp-cart-form>
      </ng-container>
      <ng-template #missingData>
        <div class="placeholder" *ngIf="!loading">
          <p>
            {{ serviceItemsError || 'Unable to display this ADDP request. Please close this dialog and try again.' }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</p-dialog>
